import { render, staticRenderFns } from "./ButtonAvatar.vue?vue&type=template&id=f5882090"
import script from "./ButtonAvatar.vue?vue&type=script&lang=js"
export * from "./ButtonAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports